import { Map, fromJS } from 'immutable'
import { createReducer } from '@cheesecakelabs/boilerplate/utils'

import { COUNTER_VALUE } from '_config/constants'

import { LOGOUT } from '../user/actions'

import {
  START_TIMER,
  DECREMENT_COUNTER,
  RESET_INTERVAL_ID,
  RESET_COUNTER_REDUX,
  ADD_NEW_ROUND,
  SET_END_TIME,
  SET_COUNTER,
} from './actions'

const INITIAL_STATE = new Map({
  counter: COUNTER_VALUE,
  intervalId: null,
  status: 'stopped',
  name: null,
  endTime: undefined,
  type: 1,
  ringCount: 0,
})

export const counter = createReducer(INITIAL_STATE, {
  [START_TIMER]: (state, { payload }) =>
    new Map(
      fromJS({
        counter: payload.seconds,
        intervalId: payload.id,
        status: 'in progress',
        name: payload.name,
        endTime: undefined,
        type: payload.type,
      })
    ),

  [DECREMENT_COUNTER]: state => state.set('counter', state.get('counter') - 1),

  [RESET_INTERVAL_ID]: state => state.set('intervalId', null),

  [RESET_COUNTER_REDUX]: () => INITIAL_STATE,

  [ADD_NEW_ROUND]: (state, { payload }) =>
    state.merge({
      intervalId: payload.id,
      counter: payload.seconds,
    }),

  [SET_END_TIME]: (state, { payload }) => state.set('endTime', payload),

  [SET_COUNTER]: (state, { payload }) => state.set('counter', payload),

  [LOGOUT]: state => {
    clearInterval(state.get('intervalId'))
    return INITIAL_STATE
  },
})



// WEBPACK FOOTER //
// ./src/modules/counter/reducers.js